module.exports = __webpack_public_path__ + "static/media/toiletChakudatsui.96ab2a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/toiletChakudatsui.png
// module id = 1700
// module chunks = 1